@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="isOem()" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-system-inputs (valueChanged)="validateAndRateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()" (systemTypeChanged)="systemTypeChanged()">
      </app-system-inputs>
      <app-indoor-air-quality (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-indoor-air-quality>
      <app-direct-drive-performance-input (valueChanged)="validateAndRateUnit()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-input>
      <app-direct-drive-performance-results [selectionEntities]="selectionEntities()"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-results>
      <app-mini-restora-mod-mechanical-connections [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()" [invalidEntities]="invalidEntities()"
        [imagePrefix]="getImagePrefix()" (valueChanged)="validateUnit()">
      </app-mini-restora-mod-mechanical-connections>
      <app-mini-restora-mod-controls [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mini-restora-mod-controls>
      <app-mini-restora-mod-valve-package-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mini-restora-mod-valve-package-options>
      <app-mini-restora-mod-primary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mini-restora-mod-primary-valve-package>
      <app-mini-restora-mod-secondary-valve-package [selectionEntities]="selectionEntities()"
        [engineKey]="getEngineKey()" [invalidEntities]="invalidEntities()"
        (valueChanged)="validateUnit()">
      </app-mini-restora-mod-secondary-valve-package>
      <app-mini-restora-mod-cabinet-features [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-mini-restora-mod-cabinet-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
